import type { SerializedError } from '@reduxjs/toolkit'
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import type { Nullable } from 'common/types'

import type { ContextMenuType } from '../../types'
import { getContextMenuCollectionAction } from './contextMenuCollectionActions'

export const contextMenuCollectionAdapter = createEntityAdapter<ContextMenuType>({
  selectId: contextMenu => contextMenu.id,
})

const contextMenuCollectionSlice = createSlice({
  name: 'contextMenuCollection',
  initialState: contextMenuCollectionAdapter.getInitialState<{
    status: string
    error: Nullable<SerializedError>
  }>({
    status: 'wait',
    error: null,
  }),
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getContextMenuCollectionAction.pending, state => {
        state.status = 'loading'
      })
      .addCase(getContextMenuCollectionAction.fulfilled, (state, action) => {
        contextMenuCollectionAdapter.upsertMany(state, action.payload)
        state.status = 'done'
      })
      .addCase(getContextMenuCollectionAction.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error
      })
  },
})

export default contextMenuCollectionSlice.reducer
